import type { Account } from '@/api';

/** True when the brand forces anonymous visitors onto the login screen. */
export function isRequireLoginScreenEnabled(account: Account | null | undefined): boolean {
  return account?.RequireLoginScreen === true;
}

/**
 * Paths reachable while logged out under RequireLoginScreen.
 * Legacy only bootstraps Login; register / forgot are stripped from the UI.
 */
export function isRequireLoginScreenPublicPath(pathname: string): boolean {
  const normalized = pathname.replace(/\/+$/, '') || '/';
  return normalized === '/login';
}

export function shouldForceRequireLoginScreen(input: {
  account: Account | null | undefined;
  loggedIn: boolean;
  pathname: string;
}): boolean {
  if (!isRequireLoginScreenEnabled(input.account)) return false;
  if (input.loggedIn) return false;
  return !isRequireLoginScreenPublicPath(input.pathname);
}
